import PageHeader from '@zenbusiness/zui/PageHeader';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledPageHeader = superstyled({
  tag: PageHeader,
  name: 'ErrorStateSection',
  slot: 'StyledPageHeader',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2),
  }),
});
